import type { ModifiableElementType } from "./store/ModifiersStoreContext";

import React from "react";

import { Tag } from "@replo/design-system/components/tag/Tag";
import {
  LucideImagePlay,
  ShoppingBag,
  SquareDashed,
  Type,
  Zap,
} from "lucide-react";

interface ElementTypeTagProps {
  elementType?: ModifiableElementType;
}

const ElementTypeTag: React.FC<ElementTypeTagProps> = ({ elementType }) => {
  if (!elementType) {
    return null;
  }

  const getElementTagDisplay = (type: ModifiableElementType) => {
    switch (type) {
      case "text":
        return { IconComponent: Type, label: "Text" };
      case "container":
        return { IconComponent: SquareDashed, label: "Container" };
      case "image":
        return { IconComponent: LucideImagePlay, label: "Media" };
      case "video":
        return { IconComponent: LucideImagePlay, label: "Media" };
      case "product-section":
        return { IconComponent: ShoppingBag, label: "Buy Box" };
      case "button":
        return { IconComponent: Zap, label: "Button" };
      case "unknown":
      default:
        return { IconComponent: SquareDashed, label: "Unknown" };
    }
  };

  const { IconComponent, label } = getElementTagDisplay(elementType);

  return (
    <Tag size="base" variant="info" startEnhancer={<IconComponent size={14} />}>
      {label}
    </Tag>
  );
};

export default ElementTypeTag;
